import { Card as DigdirCard, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const Card = React.forwardRef(({ "data-color": dataColor, "data-size": dataSize, className, role, children, style, ...props }, ref) => {
    return (React.createElement(DigdirCard, { className: cn("in-card", role ? `in-card--${role}` : "", className), "data-color": dataColor, "data-size": role ? undefined : dataSize, ref: ref, ...props, style: { ...style } }, children));
});
Card.displayName = "Card";
export { Card };
//# sourceMappingURL=card.js.map